import * as core from '../../../../../../../core'

import { query } from './award-details-info.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.award-details.widgets.info',
    description: 'Award Details',
    name: 'Award Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
